export enum Section {
    Current = 'current',
    Search = 'search',
    Another = 'another',
}
